import React from 'react';

const File = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    className="rcx-svg--directional"
    fill="currentColor"
    {...props}
  >
    <path d="M11.6667 14C11.6667 13.4477 12.1144 13 12.6667 13H19.3333C19.8856 13 20.3333 13.4477 20.3333 14C20.3333 14.5523 19.8856 15 19.3333 15H12.6667C12.1144 15 11.6667 14.5523 11.6667 14Z M12.6667 17H19.3333C19.8856 17 20.3333 17.4477 20.3333 18C20.3333 18.5523 19.8856 19 19.3333 19H12.6667C12.1144 19 11.6667 18.5523 11.6667 18C11.6667 17.4477 12.1144 17 12.6667 17Z M8 4H19.4854C19.8083 4 20.1114 4.15597 20.2991 4.41876L24.8137 10.7392C24.9349 10.9088 25 11.112 25 11.3205V27C25 27.5523 24.5523 28 24 28H8C7.44772 28 7 27.5523 7 27V5C7 4.44772 7.44772 4 8 4ZM23 11.6409L18.9708 6H9V26H23V11.6409Z" />
  </svg>
);

export default File;
